import Icon from '../Icon/Icon';
import './table.css';

type Column = {
    key: string;
    label: string;
};

type TableRenderer = {
    iconName?:
        | string
        | ((value: any, row: Record<string, any>) => string | undefined);
    render?: (value: any, row: Record<string, any>) => React.ReactNode;
};

type TableProps = {
    columns: Column[];
    title?: string;
    tableData: Record<string, any>[];
    renderers?: Record<string, TableRenderer>;
};

const Table = ({ title, columns, tableData, renderers = {} }: TableProps) => {
    return (
        <div className="table-container">
            {title && (
                <div className="table-header">
                    <h2 className="table-title">{title}</h2>
                </div>
            )}
            <table>
                <thead>
                    <tr>
                        {columns.map(c => (
                            <th key={c.key}>{c.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, i) => (
                        <tr key={i}>
                            {columns.map(c => {
                                const renderer = renderers?.[c.key];
                                const value = row[c.key];
                                const iconName =
                                    typeof renderer?.iconName === 'function'
                                        ? renderer.iconName(value, row)
                                        : renderer?.iconName;

                                return (
                                    <td key={c.key}>
                                        {iconName ? (
                                            <div className="icon-cell">
                                                <Icon
                                                    name={iconName}
                                                    className="sport-icon"
                                                />
                                                {renderer?.render
                                                    ? renderer.render(
                                                          value,
                                                          row
                                                      )
                                                    : value}
                                            </div>
                                        ) : renderer?.render ? (
                                            renderer.render(value, row)
                                        ) : (
                                            value
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
            {/* <div className="table-footer">
                <span>Showing results for current season Q3</span>
                <a href="#" className="download-link">
                    Download Detailed Report (PDF)
                </a>
            </div> */}
        </div>
    );
};

export default Table;
